/* eslint-disable no-extend-native */

if (!Array.prototype.findLast) {
  Array.prototype.findLast = function <T>(this: T[], predicate: (value: T, index: number, array: T[]) => boolean): T | undefined {
    for (let i = this.length - 1; i >= 0; i--) {
      const value = this[i];
      if (predicate(value, i, this)) {
        return value;
      }
    }

    return undefined;
  };
}

/* eslint-enable no-extend-native */
